import { render, staticRenderFns } from "./MemberForgotPassword.vue?vue&type=template&id=5c9d384a&scoped=true&"
import script from "./MemberForgotPassword.vue?vue&type=script&lang=js&"
export * from "./MemberForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./MemberForgotPassword.vue?vue&type=style&index=0&id=5c9d384a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9d384a",
  null
  
)

export default component.exports